import { render, staticRenderFns } from "./Medicals.vue?vue&type=template&id=99fe88a8&scoped=true&"
import script from "./Medicals.vue?vue&type=script&lang=js&"
export * from "./Medicals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fe88a8",
  null
  
)

export default component.exports